import { render, staticRenderFns } from "./Tippy.vue?vue&type=template&id=5a920d1d&scoped=true&"
import script from "./Tippy.vue?vue&type=script&lang=js&"
export * from "./Tippy.vue?vue&type=script&lang=js&"
import style0 from "./Tippy.vue?vue&type=style&index=0&id=5a920d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a920d1d",
  null
  
)

export default component.exports